module.exports = __webpack_public_path__ + "img/fig38.777865f4.jpg";